import { useFlagsStore } from '@/features/flags/flags.store'
import type { FeatureFlagStatus } from '@/types/models'

export interface FeatureState {
  status: FeatureFlagStatus
  isEnabled: boolean
  /** Show the entry point greyed out with the "coming soon" copy; do not let it work. */
  isComingSoon: boolean
  /** Enabled or coming soon: the entry point appears at all. Disabled/deprecated hide it. */
  isVisible: boolean
}

/** Read one flag. Before the flags load (guests, boot) everything reads as disabled. */
export function useFeature(key: string): FeatureState {
  const status = useFlagsStore((s) => s.flags[key] ?? 'disabled')
  return { status, isEnabled: status === 'enabled', isComingSoon: status === 'comingSoon', isVisible: status === 'enabled' || status === 'comingSoon' }
}
